import React from 'react';
import { DropdownSearchSelect, DropdownSelect } from '../../../../components/Dropdown';
import { TextInput } from '../../../../components/TextInput';
import { PdfDataKey } from '../../data/PdfDataKey';
import { PdfFieldResolving } from '../../data/PdfFieldResolving';
import { PdfImageComponent, PdfImageFit } from '../../PdfComponent';
import { usePdfTemplateContext } from '../../PdfTemplateEditorContext';
import PdfTemplateComponentDefault from '../properties/PdfTemplateComponentDefault';

export default function PdfTemplateImageComponentProperties<T>({ component }: { component: PdfImageComponent }) {
  const { updateComponent, imageDataKeys, data } = usePdfTemplateContext<T>();

  return (
    <div className='grid gap-2'>
      <PdfTemplateComponentDefault component={component} />

      <p className='section-title mt-2'>Content</p>
      <div>
        <input
          type='file'
          style={{ width: '100%' }}
          accept='image/png,image/jpeg'
          onChange={async e => {
            const file = e.target.files?.[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = () => {
              const dataUrl = String(reader.result);
              const imgEl = new Image();
              imgEl.onload = () => {
                updateComponent(component.id, {
                  src: dataUrl,
                  naturalWidthPx: imgEl.naturalWidth,
                  naturalHeightPx: imgEl.naturalHeight,
                  key: undefined,
                });
              };
              imgEl.src = dataUrl;
            };
            reader.readAsDataURL(file);
          }}
        />
      </div>
      {!!imageDataKeys.length && (
        <div>
          <DropdownSearchSelect<PdfDataKey<any>>
            placeholder={'Or select an image datakey'}
            label={'Image datakey'}
            items={imageDataKeys}
            textBuilder={key => PdfFieldResolving.getLabel(key, data)}
            onSelect={key => updateComponent(component.id, { key, src: undefined })}
            value={component.key}
          />
        </div>
      )}

      <div className='grid grid-cols-4 gap-2'>
        <div className='col-span-3'>
          <DropdownSelect<PdfImageFit>
            label={'Fit'}
            textBuilder={f => f}
            items={Object.values(PdfImageFit)}
            value={component.fit}
            onSelect={fit => updateComponent(component.id, { fit })}
          />
        </div>

        <div className='col-span-1'>
          <TextInput
            label={'Opacity'}
            type={'number'}
            value={component.opacity}
            onChange={value => {
              updateComponent(component.id, { opacity: Number(value) });
            }}
            min={0}
            max={1}
          />
        </div>
      </div>
      {component.naturalWidthPx && component.naturalHeightPx ? (
        <div className='text-xs text-gray-500'>
          Image pixels: {component.naturalWidthPx}×{component.naturalHeightPx} px · Drawn size: {component.width}×
          {component.height} mm
        </div>
      ) : null}
    </div>
  );
}
